import 'jquery.cookie';
import { format } from 'date-fns';
import isMobileVersion from '@/js/common/Service/isMobileVersion';

export default (options) => {
    const getSource = (isMobile) => {
        if (isMobile === null) {
            return null;
        }

        return isMobile
            ? 'wl-mobweb'
            : 'wl-desktop';
    };

    return {
        ga_id: $.cookie('_ga') || 0,
        ya_id: $.cookie('_ym_uid') || 0,
        domain: window.location.host,
        source: getSource(isMobileVersion()),
        timestamp: options.timestamp ? format(options.timestamp, 'yyyy-MM-dd HH:mm:ss', new Date()) : null,
    };
};